<script setup lang="ts">
import ImageWithFallback from './ImageWithFallback.vue';

withDefaults(
  defineProps<{
    imageUrl?: string;
    fromColor?: string;
    toColor?: string;
    flip?: boolean;
  }>(),
  {
    imageUrl: '',
    fromColor: '#221a33',
    toColor: '#1e1530',
    flip: false,
  },
);
</script>

<template>
  <div class="ai-divider" :style="{ '--from': fromColor, '--to': toColor }">
    <ImageWithFallback
      v-if="imageUrl"
      :src="imageUrl"
      alt=""
      aria-hidden="true"
      class="ai-divider__image"
      :class="{ 'ai-divider__image--flip': flip }"
    />
    <div class="ai-divider__tint"></div>
    <div class="ai-divider__fade"></div>
    <div class="ai-divider__line"></div>
  </div>
</template>

<style scoped lang="scss">
.ai-divider {
  position: relative;
  height: 10rem;
  overflow: hidden;
}

.ai-divider__image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.2;
}

.ai-divider__image--flip {
  object-position: center bottom;
}

.ai-divider__tint {
  position: absolute;
  inset: 0;
  background: rgba(34, 26, 51, 0.5);
}

.ai-divider__fade {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    var(--from) 0%,
    transparent 35%,
    transparent 65%,
    var(--to) 100%
  );
}

.ai-divider__line {
  position: absolute;
  inset-inline: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(0, 191, 116, 0.25), transparent);
}

@media (max-width: 800px) {
  .ai-divider {
    height: 8rem;
  }
}
</style>
